export default "__VITE_ASSET__DCxmdGcb__"